export const enum WorkTypeSorting {
  NO_WORK_TYPE_SORTING = 0,
  SINGLE_SORTING = 1,
  MANUAL_SORTING = 2,
  MULTI_SORTING = 3
}
